import React from 'react';
import { useProductImage } from '@js/api';

function VarietyProduct({ product, params }) {
  const { data, isLoading } = useProductImage(product.id);

  return (
    <div className="VarietyProduct">
      <a href={product.url} className="VarietyProduct-title" target='_blank' rel="noreferrer">
        {product.title}
      </a>
      <p className="VarietyProduct-type">
        {product.Type}
      </p>
      <p className="mb-8 VarietyProduct-type sm:mb-14">
        {params.precocity}
      </p>
      <a href={product.url} className="VarietyProduct-image" target='_blank' rel="noreferrer">
        {isLoading || !data[0] ? (
        <img src={window.PLACEHOLDER_IMAGE} alt={`${product.title} visuel`} />
        ): (
        <img src={data[0]?.url || window.PLACEHOLDER_IMAGE} alt={`${product.title} visuel`} />
        )}
      </a>
    </div>
  );
}

export default VarietyProduct;
